import { forwardRef, Ref } from 'react';
import { Dropdown as DropdownPR, DropdownChangeEvent, DropdownProps } from 'primereact/dropdown';
import { ChevronIcon } from './icons';

export const Dropdown = forwardRef((props: DropdownProps, ref?: Ref<DropdownPR>) => {
  return (
    <DropdownPR
      ref={ref}
      {...props}
      dropdownIcon={props.dropdownIcon || <ChevronIcon />}
      collapseIcon={props.collapseIcon || <ChevronIcon className="rotate-180" />}
    />
  );
});

export type { DropdownChangeEvent, DropdownProps };
